import axios from "axios";
import { convertTimeToTodayNet } from "../../util/datetime";
export const IMPORTAR_NOMINA = "IMPORTAR_NOMINA";
export const EXISTE_NOMINA = "EXISTE_NOMINA";
export const POST_DATOS_PARTICULARES = "POST_DATOS_PARTICULARES";
export const CLEAR_EXISTE_NOMINA = "CLEAR_EXISTE_NOMINA";
export const POST_LAST_FORM = "POST_LAST_FORM";
export const POST_DATOS_DOMICILIARIOS = "POST_DATOS_DOMICILIARIOS";
export const POST_DATOS_NOMINALES = "POST_DATOS_NOMINALES";
export const CLEAR_DATOS_POST_NOMINA = "CLEAR_DATOS_POST_NOMINA";
export const CLEAR_NOMINA = "CLEAR_NOMINA";
export const SAVE_CUIL = "SAVE_CUIL";
export const GET_NOMINA_ACTIVA_COMBO_BOX = "GET_NOMINA_ACTIVA_COMBO_BOX";
export const GET_TEMPLATE_NOMINA = "GET_TEMPLATE_NOMINA";
export const GET_INFO_ESTRUCTURA_ARCHIVO = "GET_INFO_ESTRUCTURA_ARCHIVO";
export const GET_CANTIDAD_DIAS_INGRESO_FUTURO = "GET_CANTIDAD_DIAS_INGRESO_FUTURO";
export const GET_NOMINA_COMPLETA = "GET_NOMINA_COMPLETA";
export const EXPORTAR_EXCEL_NOMINA = "EXPORTAR_EXCEL_NOMINA";

export const importarNomina = (body) => (dispatch) => {
  return dispatch({
    type: IMPORTAR_NOMINA,
    payload: axios
      .post("nomina/importar", body)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const existeNomina = (cuil) => (dispatch) => {
  return dispatch({
    type: EXISTE_NOMINA,
    payload: axios
      .get(`nomina/existeNomina?cuil=${cuil}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const sendAllNominaForm = (data) => (dispatch) => {
  const payload = {
    ...data,
    ...(data?.horaDesde !== undefined && {
      horaDesde: convertTimeToTodayNet(data.horaDesde),
    }),
    ...(data?.horaHasta !== undefined && {
      horaHasta: convertTimeToTodayNet(data.horaHasta),
    }),
  };
  return dispatch({
    type: POST_LAST_FORM,
    payload: axios
      .post(`nomina/cargarNomina`, payload)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const saveDatosDomiciliarios = (data) => (dispatch) => {
  return dispatch({
    type: POST_DATOS_DOMICILIARIOS,
    payload: data,
  });
};
export const saveDatosParticulares = (data) => (dispatch) => {
  return dispatch({
    type: POST_DATOS_PARTICULARES,
    payload: data,
  });
};
export const saveDatosNominales = (data) => (dispatch) => {
  return dispatch({
    type: POST_DATOS_NOMINALES,
    payload: data,
  });
};
export const clearPostNomina = () => (dispatch) => {
  return dispatch({
    type: CLEAR_DATOS_POST_NOMINA,
  });
};
export const clearExisteNomina = () => (dispatch) => {
  return dispatch({
    type: CLEAR_EXISTE_NOMINA,
  });
};
export const setSearchedCuil = (cuil) => (dispatch) => {
  return dispatch({
    type: SAVE_CUIL,
    payload: cuil,
  });
};
export const clearNomina = () => (dispatch) => {
  return dispatch({
    type: CLEAR_NOMINA,
  });
};

export const getNominaActivaComboBox = (idDependenciaEmpleador, fechaPresentacion) => (dispatch) => {
  return dispatch({
    type: GET_NOMINA_ACTIVA_COMBO_BOX,
    payload: axios
      .get(`nomina/activasEstablecimiento?idDependenciaEmpleador=${idDependenciaEmpleador}&fechaPresentacion=${fechaPresentacion}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTemplateNomina = () => (dispatch) => {
  return dispatch({
    type: GET_TEMPLATE_NOMINA,
    payload: axios
      .get(`nomina/descargarTemplateImportacion`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getInfoEstructuraArchivo = () => (dispatch) => {
  return dispatch({
    type: GET_INFO_ESTRUCTURA_ARCHIVO,
    payload: axios
      .get(`nomina/visualizarInfoEstructuraArchivo`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getCantidadDiasIngresoFuturoNomina = () => (dispatch) => {
  return dispatch({
    type: GET_CANTIDAD_DIAS_INGRESO_FUTURO,
    payload: axios
      .get(`nomina/cantidadDiasIngresoFuturo`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getNominaCompleta = () => (dispatch) => {
  return dispatch({
    type: GET_NOMINA_COMPLETA,
    payload: axios
      .get(`nomina/completas`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const exportarExcelNomina = () => (dispatch) => {
  return dispatch({
    type: EXPORTAR_EXCEL_NOMINA,
    payload: axios
      .get(`nomina/completas/excel`, { responseType: "blob" })
      .then((response) => {
        let fileName = response?.headers["content-disposition"]?.split("filename=")[1];
        return { data: response.data, fileName };
      })
      .catch((error) => Promise.reject(error)),
  });
};
